import { useAuthStore } from '@tundr/auth';
import { useFeatureFlag } from '@tundr/feature-flags';
import { computed, type ComputedRef } from 'vue';

export const MEAL_VOUCHER_UI_HR_MANUAL_ASSIGNMENT_FLAG =
  'meal-vouchers.ui.hr-manual-assignment' as const;
export const MEAL_VOUCHER_UI_V3_EMPLOYEE_DETAILS_FLAG =
  'meal-vouchers.ui.v3.employee_details' as const;
export const MEAL_VOUCHER_UI_V3_CARD_ORDERS_FLAG =
  'meal-vouchers.ui.v3.card_orders' as const;

const withMealVoucher = (isEnabled: ComputedRef<boolean>) => {
  const authStore = useAuthStore();
  return computed(() => isEnabled.value && authStore.hasMealVoucher);
};

export const isMealVoucherEmployeeDetailsAvailable = (): ComputedRef<boolean> =>
  withMealVoucher(useFeatureFlag(MEAL_VOUCHER_UI_V3_EMPLOYEE_DETAILS_FLAG));

export const isMealVoucherCardOrdersAvailable = (): ComputedRef<boolean> =>
  withMealVoucher(useFeatureFlag(MEAL_VOUCHER_UI_V3_CARD_ORDERS_FLAG));

export const isMealVoucherHrManualAssignmentAvailable =
  (): ComputedRef<boolean> =>
    withMealVoucher(useFeatureFlag(MEAL_VOUCHER_UI_HR_MANUAL_ASSIGNMENT_FLAG));
